(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["FOOTER-2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const query = window.matchMedia('(max-width: 749px)');
    const menus = () => document.querySelectorAll('.footer-2--collapse-mobile .footer-2__menu');
    const syncMenus = () => {
      menus().forEach((menu) => {
        if (query.matches) {
          menu.removeAttribute('open');
        } else {
          menu.setAttribute('open', '');
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncMenus);
    } else {
      syncMenus();
    }

    if (typeof query.addEventListener === 'function') {
      query.addEventListener('change', syncMenus);
    } else if (typeof query.addListener === 'function') {
      query.addListener(syncMenus);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campaign-offer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lorzor-campaign-offer')) {
    customElements.define('lorzor-campaign-offer', class extends HTMLElement {
      connectedCallback() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (!this.isConnected) return;
        this.cleanup?.abort();
        clearInterval(this.clock);
        this.cleanup = new AbortController();
        this.copyButton = this.querySelector('[data-copy]');
        this.copyButton.hidden = false;
        this.copyButton.disabled = false;
        this.copyButton.querySelector('[data-copy-label]').hidden = false;
        this.copyButton.querySelector('[data-copied-label]').hidden = true;
        this.querySelector('[data-copy-feedback]').textContent = '';
        clearTimeout(this.resetTimer);
        this.copyButton.addEventListener('click', () => this.copyCode(), { signal: this.cleanup.signal });
        document.addEventListener('visibilitychange', () => this.updateState(), { signal: this.cleanup.signal });
        this.updateState();
        this.clock = setInterval(() => this.updateState(), 15000);
      }
      disconnectedCallback() { cancelAnimationFrame(this.frame); this.cleanup?.abort(); clearInterval(this.clock); clearTimeout(this.resetTimer); }
      getState() {
        const d = this.dataset;
        if (d.preview === 'true') return 'active';
        if (d.enabled !== 'true') return 'off';
        const start = Date.parse(d.start), end = Date.parse(d.end);
        if (d.valid !== 'true' || !Number.isFinite(start) || !Number.isFinite(end) || end <= start) return 'invalid';
        if (d.currencyOk !== 'true') return 'currency';
        const now = Date.now();
        return now < start ? 'scheduled' : now >= end ? 'ended' : 'active';
      }
      updateState() {
        const state = this.getState();
        this.dataset.state = state;
        this.querySelectorAll('[data-campaign-active]').forEach(el => { el.hidden = state !== 'active'; });
        this.querySelectorAll('[data-campaign-inactive]').forEach(el => { el.hidden = state === 'active'; });
        this.querySelectorAll('[data-campaign-status]').forEach(el => { el.hidden = el.dataset.campaignStatus !== state; });
        this.querySelectorAll('[data-campaign-scheduled]').forEach(el => { el.hidden = state !== 'scheduled'; });
        if (state !== 'active') this.querySelector('[data-copy-feedback]').textContent = '';
        return state;
      }
      async copyCode() {
        if (this.updateState() !== 'active') return;
        const codeElement = this.querySelector('[data-code]');
        const button = this.copyButton;
        const feedback = this.querySelector('[data-copy-feedback]');
        button.disabled = true;
        button.querySelector('[data-copy-label]').hidden = false;
        button.querySelector('[data-copied-label]').hidden = true;
        feedback.textContent = '';
        clearTimeout(this.resetTimer);
        try {
          if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(codeElement.textContent.trim());
          if (!this.isConnected || this.updateState() !== 'active') return;
          button.querySelector('[data-copy-label]').hidden = true;
          button.querySelector('[data-copied-label]').hidden = false;
          feedback.textContent = this.dataset.copySuccess;
        } catch {
          if (!this.isConnected || this.updateState() !== 'active') return;
          const range = document.createRange();
          range.selectNodeContents(codeElement);
          const selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
          feedback.textContent = this.dataset.copyFailed;
        } finally {
          button.disabled = false;
          this.resetTimer = setTimeout(() => {
            if (!this.isConnected) return;
            button.querySelector('[data-copy-label]').hidden = false;
            button.querySelector('[data-copied-label]').hidden = true;
            feedback.textContent = '';
          }, 6000);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campaign-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lorzor-campaign-products')) {
    customElements.define('lorzor-campaign-products', class extends HTMLElement {
      connectedCallback() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (!this.isConnected) return;
        this.cleanup?.abort();
        clearInterval(this.clock);
        this.cleanup = new AbortController();
        document.addEventListener('visibilitychange', () => this.updatePrices(), { signal: this.cleanup.signal });
        this.updatePrices();
        this.clock = setInterval(() => this.updatePrices(), 15000);
      }
      disconnectedCallback() { cancelAnimationFrame(this.frame); this.cleanup?.abort(); clearInterval(this.clock); }
      updatePrices() {
        const d = this.dataset;
        const start = Date.parse(d.start), end = Date.parse(d.end), now = Date.now();
        const valid = d.valid === 'true' && d.currencyOk === 'true' && Number.isFinite(start) && Number.isFinite(end) && end > start;
        const active = valid && (d.preview === 'true' || (d.enabled === 'true' && now >= start && now < end));
        this.querySelectorAll('[data-campaign-price]').forEach(el => { el.hidden = !active; });
        this.querySelectorAll('.lcp__product').forEach(card => {
          const estimate = card.querySelector('[data-campaign-price]');
          card.querySelector('[data-regular-price]').hidden = Boolean(active && estimate);
        });
        const note = this.querySelector('[data-campaign-note]');
        if (note) note.hidden = !active || !this.querySelector('[data-campaign-price]');
        this.dataset.active = String(active);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-media-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lorzor-media-tabs')) {
    customElements.define(
      'lorzor-media-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[data-lmt-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-lmt-panel]'));

          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.activate(tab, false));
            tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
          });

          this.onBlockSelect = (event) => {
            const panel = event.target.closest('[data-lmt-panel]');
            if (!panel || !this.contains(panel)) return;
            const tab = this.tabs.find((item) => item.getAttribute('aria-controls') === panel.id);
            if (tab) this.activate(tab, false);
          };

          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }

        disconnectedCallback() {
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        activate(activeTab, moveFocus) {
          this.tabs.forEach((tab) => {
            const isActive = tab === activeTab;
            tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
            tab.tabIndex = isActive ? 0 : -1;
          });

          this.panels.forEach((panel) => {
            panel.hidden = panel.id !== activeTab.getAttribute('aria-controls');
          });

          if (moveFocus) activeTab.focus();
        }

        onKeydown(event, currentTab) {
          const currentIndex = this.tabs.indexOf(currentTab);
          let nextIndex = currentIndex;

          if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.tabs.length - 1;

          if (nextIndex !== currentIndex) {
            event.preventDefault();
            this.activate(this.tabs[nextIndex], true);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-contact-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const scriptUrl = 'https://www.17track.net/externalcall.js';
    let trackingScriptPromise;

    const loadTrackingScript = () => {
      if (window.YQV5 && typeof window.YQV5.trackSingle === 'function') {
        return Promise.resolve();
      }

      if (trackingScriptPromise) {
        return trackingScriptPromise;
      }

      trackingScriptPromise = new Promise((resolve, reject) => {
        const existingScript = document.querySelector(`script[src="${scriptUrl}"]`);

        if (existingScript) {
          if (existingScript.dataset.loaded === 'true') {
            resolve();
            return;
          }
          existingScript.addEventListener('load', resolve, { once: true });
          existingScript.addEventListener('error', reject, { once: true });
          window.setTimeout(() => {
            if (window.YQV5 && typeof window.YQV5.trackSingle === 'function') {
              resolve();
            }
          }, 1500);
          return;
        }

        const script = document.createElement('script');
        script.src = scriptUrl;
        script.async = true;
        script.onload = () => {
          script.dataset.loaded = 'true';
          resolve();
        };
        script.onerror = reject;
        document.head.appendChild(script);
      });

      return trackingScriptPromise;
    };

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-support-tracking-form]');

      if (!form) {
        return;
      }

      event.preventDefault();

      const input = form.querySelector('input[name="tracking_number"]');
      const error = form.querySelector('[data-support-tracking-error]');
      const result = document.getElementById(form.dataset.resultId);
      const trackingNumber = input ? input.value.trim() : '';

      if (!trackingNumber) {
        if (error) {
          error.hidden = false;
        }
        if (input) {
          input.focus();
        }
        return;
      }

      if (error) {
        error.hidden = true;
      }

      if (result) {
        result.innerHTML = '';
      }

      loadTrackingScript()
        .then(() => {
          if (!window.YQV5 || typeof window.YQV5.trackSingle !== 'function') {
            throw new Error('17TRACK widget unavailable');
          }

          window.YQV5.trackSingle({
            YQ_ContainerId: form.dataset.resultId,
            YQ_Height: Number(form.dataset.height) || 560,
            YQ_Fc: form.dataset.carrier || '0',
            YQ_Lang: form.dataset.language || 'en',
            YQ_Num: trackingNumber
          });
        })
        .catch(() => {
          if (error) {
            error.textContent = 'Tracking is temporarily unavailable. Please try again later or contact support.';
            error.hidden = false;
          }
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-hero-search"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const scriptUrl = 'https://www.17track.net/externalcall.js';
    let trackingScriptPromise;

    const loadTrackingScript = () => {
      if (window.YQV5 && typeof window.YQV5.trackSingle === 'function') {
        return Promise.resolve();
      }

      if (trackingScriptPromise) {
        return trackingScriptPromise;
      }

      trackingScriptPromise = new Promise((resolve, reject) => {
        const existingScript = document.querySelector(`script[src="${scriptUrl}"]`);

        if (existingScript) {
          if (existingScript.dataset.loaded === 'true') {
            resolve();
            return;
          }
          existingScript.addEventListener('load', resolve, { once: true });
          existingScript.addEventListener('error', reject, { once: true });
          window.setTimeout(() => {
            if (window.YQV5 && typeof window.YQV5.trackSingle === 'function') {
              resolve();
            }
          }, 1500);
          return;
        }

        const script = document.createElement('script');
        script.src = scriptUrl;
        script.async = true;
        script.onload = () => {
          script.dataset.loaded = 'true';
          resolve();
        };
        script.onerror = reject;
        document.head.appendChild(script);
      });

      return trackingScriptPromise;
    };

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-support-hero-tracking-form]');

      if (!form) {
        return;
      }

      event.preventDefault();

      const input = form.querySelector('input[name="tracking_number"]');
      const error = form.querySelector('[data-support-hero-tracking-error]');
      const result = document.getElementById(form.dataset.resultId);
      const trackingNumber = input ? input.value.trim() : '';

      if (!trackingNumber) {
        if (error) {
          error.hidden = false;
        }
        if (input) {
          input.focus();
        }
        return;
      }

      if (error) {
        error.hidden = true;
      }

      if (result) {
        result.innerHTML = '';
      }

      loadTrackingScript()
        .then(() => {
          if (!window.YQV5 || typeof window.YQV5.trackSingle !== 'function') {
            throw new Error('17TRACK widget unavailable');
          }

          window.YQV5.trackSingle({
            YQ_ContainerId: form.dataset.resultId,
            YQ_Height: Number(form.dataset.height) || 560,
            YQ_Fc: form.dataset.carrier || '0',
            YQ_Lang: form.dataset.language || 'en',
            YQ_Num: trackingNumber
          });
        })
        .catch(() => {
          if (error) {
            error.textContent = 'Tracking is temporarily unavailable. Please try again later or contact support.';
            error.hidden = false;
          }
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["use-cases-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lorzor-use-cases')) {
    customElements.define(
      'lorzor-use-cases',
      class extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('[data-luc-viewport]');
          this.track = this.querySelector('[data-luc-track]');
          this.cards = Array.from(this.querySelectorAll('[data-luc-card]'));
          this.previousButton = this.querySelector('[data-luc-previous]');
          this.nextButton = this.querySelector('[data-luc-next]');
          this.slidesPerClick = Number(this.dataset.slidesPerClick || 1);
          this.drag = null;
          this.didDrag = false;

          if (!this.viewport || !this.track || this.cards.length === 0) return;

          this.onPrevious = () => this.scrollByCards(-this.slidesPerClick);
          this.onNext = () => this.scrollByCards(this.slidesPerClick);
          this.onScroll = () => this.requestControlUpdate();
          this.onKeydown = (event) => this.handleKeydown(event);
          this.onPointerDown = (event) => this.handlePointerDown(event);
          this.onPointerMove = (event) => this.handlePointerMove(event);
          this.onPointerUp = (event) => this.handlePointerUp(event);
          this.onClickCapture = (event) => {
            if (!this.didDrag) return;
            event.preventDefault();
            event.stopPropagation();
            this.didDrag = false;
          };
          this.onBlockSelect = (event) => {
            const card = event.target.closest('[data-luc-card]');
            if (!card || !this.contains(card)) return;
            card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          };

          this.previousButton?.addEventListener('click', this.onPrevious);
          this.nextButton?.addEventListener('click', this.onNext);
          this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
          this.viewport.addEventListener('keydown', this.onKeydown);
          this.viewport.addEventListener('pointerdown', this.onPointerDown);
          this.viewport.addEventListener('pointermove', this.onPointerMove);
          this.viewport.addEventListener('pointerup', this.onPointerUp);
          this.viewport.addEventListener('pointercancel', this.onPointerUp);
          this.viewport.addEventListener('click', this.onClickCapture, true);
          document.addEventListener('shopify:block:select', this.onBlockSelect);

          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(() => this.updateControls());
            this.resizeObserver.observe(this.viewport);
          } else {
            this.onWindowResize = () => this.updateControls();
            window.addEventListener('resize', this.onWindowResize);
          }
          this.updateControls();
        }

        disconnectedCallback() {
          this.previousButton?.removeEventListener('click', this.onPrevious);
          this.nextButton?.removeEventListener('click', this.onNext);
          this.viewport?.removeEventListener('scroll', this.onScroll);
          this.viewport?.removeEventListener('keydown', this.onKeydown);
          this.viewport?.removeEventListener('pointerdown', this.onPointerDown);
          this.viewport?.removeEventListener('pointermove', this.onPointerMove);
          this.viewport?.removeEventListener('pointerup', this.onPointerUp);
          this.viewport?.removeEventListener('pointercancel', this.onPointerUp);
          this.viewport?.removeEventListener('click', this.onClickCapture, true);
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
          this.resizeObserver?.disconnect();
          if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
          if (this.controlFrame) cancelAnimationFrame(this.controlFrame);
        }

        cardStep() {
          const card = this.cards[0];
          if (!card) return this.viewport.clientWidth;
          const gap = parseFloat(getComputedStyle(this.track).columnGap || 0);
          return card.getBoundingClientRect().width + gap;
        }

        scrollByCards(count) {
          this.viewport.scrollBy({ left: this.cardStep() * count, behavior: 'smooth' });
        }

        handleKeydown(event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.scrollByCards(event.key === 'ArrowRight' ? 1 : -1);
        }

        handlePointerDown(event) {
          if (event.pointerType === 'touch' || event.button !== 0) return;
          event.preventDefault();
          this.drag = { id: event.pointerId, startX: event.clientX, startScroll: this.viewport.scrollLeft };
          this.didDrag = false;
          this.viewport.setPointerCapture(event.pointerId);
          this.viewport.classList.add('is-dragging');
        }

        handlePointerMove(event) {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          event.preventDefault();
          const delta = event.clientX - this.drag.startX;
          if (Math.abs(delta) > 5) this.didDrag = true;
          this.viewport.scrollLeft = this.drag.startScroll - delta;
        }

        handlePointerUp(event) {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          if (this.viewport.hasPointerCapture(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);
          this.viewport.classList.remove('is-dragging');
          this.drag = null;
          this.requestControlUpdate();
          window.setTimeout(() => {
            if (!this.didDrag) return;
            this.didDrag = false;
          }, 0);
        }

        requestControlUpdate() {
          if (this.controlFrame) return;
          this.controlFrame = requestAnimationFrame(() => {
            this.controlFrame = null;
            this.updateControls();
          });
        }

        updateControls() {
          if (!this.viewport) return;
          const max = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
          if (this.previousButton) this.previousButton.disabled = this.viewport.scrollLeft <= 2;
          if (this.nextButton) this.nextButton.disabled = this.viewport.scrollLeft >= max - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
